import { render } from "./drag-wrapper.vue?vue&type=template&id=a4ec54f4"
import script from "./drag-wrapper.vue?vue&type=script&lang=ts"
export * from "./drag-wrapper.vue?vue&type=script&lang=ts"
script.render = render

export default script